import {defineAsyncComponent} from 'vue';

const dictionaryDeclarationPopup = defineAsyncComponent(() =>
  import('@/views/initialInformationDeclaration/DictionaryDeclarationPopup.vue'),
);
const videoSoftwareIntroduction = defineAsyncComponent(() =>
  import('@/views/initialInformationDeclaration/VideoSoftwareIntroduction.vue'),
);

const expireDateContent = defineAsyncComponent(() => import('@/views/dictionary/license/ExpireDateContent.vue'));
const listVoucherOffline = defineAsyncComponent(() => import('@/views/voucherOffline/ListVoucherOffline.vue'));
const synchronousResults = defineAsyncComponent(() => import('@/views/voucherOffline/SynchronousResults.vue'));
const notifyOffline = defineAsyncComponent(() => import('@/components/pwa/NotifyOffline.vue'));
const dashboardCashBalanceDepositDetail = defineAsyncComponent(() =>
  import('@/views/dashboard/DashboardCashBalanceDepositDetail.vue'),
);
const DashboardPayableDebtDetail = defineAsyncComponent(() =>
  import('@/views/dashboard/DashboardPayableDebtDetail.vue'),
);
const DashboardReceivableDebtDetail = defineAsyncComponent(() =>
  import('@/views/dashboard/DashboardReceivableDebtDetail.vue'),
);

export function registerDashboard(app) {
  app.component('DictionaryDeclarationPopup', dictionaryDeclarationPopup);
  app.component('VideoSoftwareIntroduction', videoSoftwareIntroduction);
  app.component('ExpireDateContent', expireDateContent);
  app.component('ListVoucherOffline', listVoucherOffline);
  app.component('SynchronousResults', synchronousResults);
  app.component('NotifyOffline', notifyOffline);
  app.component('DashboardCashBalanceDepositDetail', dashboardCashBalanceDepositDetail);
  app.component('DashboardPayableDebtDetail', DashboardPayableDebtDetail);
  app.component('DashboardReceivableDebtDetail', DashboardReceivableDebtDetail);
}
